import React, { createContext, useState, useContext, useEffect } from 'react';

const AppContext = createContext();

export const useApp = () => {
  return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
  const [isPWA, setIsPWA] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if app is installed as PWA
    const checkPWA = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      setIsPWA(isStandalone);
    };

    // Check if device is mobile
    const checkMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
    };

    checkPWA();
    checkMobile();

    // Add listeners for changes
    const pwaMediaQuery = window.matchMedia('(display-mode: standalone)');
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

    const handlePWAChange = (e) => setIsPWA(e.matches);
    const handleMobileChange = (e) => setIsMobile(e.matches);

    pwaMediaQuery.addEventListener('change', handlePWAChange);
    mobileMediaQuery.addEventListener('change', handleMobileChange);

    return () => {
      pwaMediaQuery.removeEventListener('change', handlePWAChange);
      mobileMediaQuery.removeEventListener('change', handleMobileChange);
    };
  }, []);

  const value = {
    isPWA,
    isMobile
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}; 